// extracted by mini-css-extract-plugin
export default {"About":"About_About__vdptC","TwoCol":"About_TwoCol__dD8Xa","ColOne":"About_ColOne__qZCfG","Cta":"About_Cta__hmUXO","Synopsis":"About_Synopsis__QCVGL","ColTwo":"About_ColTwo__C2YaY"};